import { GET_REGIONS } from "./restaurant.actionsTypes";

export default function regions(state = [], action) {
    switch (action.type) {
        case GET_REGIONS:
            return action.regions || [];
        default:
            return state;
    }
}
